import { render, staticRenderFns } from "./TCModal.vue?vue&type=template&id=78dfa9d6&scoped=true"
import script from "./TCModal.vue?vue&type=script&lang=js"
export * from "./TCModal.vue?vue&type=script&lang=js"
import style0 from "./TCModal.vue?vue&type=style&index=0&id=78dfa9d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dfa9d6",
  null
  
)

export default component.exports